import { render, staticRenderFns } from "./EasyDataList.vue?vue&type=template&id=51632bde&scoped=true"
import script from "./EasyDataList.vue?vue&type=script&lang=js"
export * from "./EasyDataList.vue?vue&type=script&lang=js"
import style0 from "./EasyDataList.vue?vue&type=style&index=0&id=51632bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51632bde",
  null
  
)

export default component.exports